var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlowcarlogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80.063,
    height: 65.766,
    viewBox: "0 0 80.063 65.766",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_9229725711595988886",
    "data-name": 9229725711595990000,
    d: "M76.344,27.875H79.2a2.7,2.7,0,0,0,2.859-2.859A2.7,2.7,0,0,0,79.2,22.156H71.2l-3.431-8.578A14.448,14.448,0,0,0,54.612,5H29.736A14.553,14.553,0,0,0,16.3,13.578L12.58,22.156H4.859A2.7,2.7,0,0,0,2,25.016a2.7,2.7,0,0,0,2.859,2.859H7.719A14.491,14.491,0,0,0,2,39.313V50.75a8.193,8.193,0,0,0,2.859,6.291v5.147a8.425,8.425,0,0,0,8.578,8.578h5.719a8.425,8.425,0,0,0,8.578-8.578V59.328H56.328v2.859a8.425,8.425,0,0,0,8.578,8.578h5.719A8.425,8.425,0,0,0,79.2,62.188V57.041a8.193,8.193,0,0,0,2.859-6.291V39.313A14.491,14.491,0,0,0,76.344,27.875Zm-2.859,14.3a2.7,2.7,0,0,1-2.859,2.859H62.047a2.859,2.859,0,0,1,0-5.719h8.578A2.7,2.7,0,0,1,73.484,42.172ZM13.438,39.313h8.578a2.859,2.859,0,0,1,0,5.719H13.438a2.859,2.859,0,0,1,0-5.719Zm12.581,14.3,3.431-6.577a8.611,8.611,0,0,1,7.72-4.861H47.178a8.427,8.427,0,0,1,7.72,4.861l3.431,6.577ZM21.73,15.866a8.4,8.4,0,0,1,7.72-5.147H54.327a8.8,8.8,0,0,1,8.006,5.147l4,9.15H17.727Z",
    transform: "translate(-2 -5)",
    fill: "#16b1ef"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowcarlogo);
export default __webpack_public_path__ + "static/media/flowcarlogo.a5ead7f16c705821c32af3b9b2d4c026.svg";
export { ForwardRef as ReactComponent };